<template>
  <Page title="Invoices">
    <template v-slot:actions>
      <v-btn @click="handleAddInvoice" color="primary">
        <v-icon left>mdi-plus</v-icon>
        Cadastrar
      </v-btn>
    </template>

    <v-container fluid>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
        >
          <template v-slot:item.invoice_number="{ item }">
            <router-link :to="`/admin/invoices/${item.invoice_number}`">
              Número {{ item.invoice_number }}
            </router-link>
          </template>
          <template v-slot:item.amount="{ item }">
            {{ euro(item.amount) }}
          </template>
          <template v-slot:item.date="{ item }">
            {{ formatDate(item.date) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item :to="`/admin/invoices/${item.invoice_number}`">
                  <v-list-item-title>
                    <v-icon left>mdi-chevron-right</v-icon>
                    Acessar
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  :to="`/admin/invoices/${item.invoice_number}/edit`"
                >
                  <v-list-item-title>
                    <v-icon left>mdi-pencil</v-icon>
                    Editar
                  </v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="deleteInvoice(item.invoice_number)">
                  <v-list-item-title class="red--text">
                    <v-icon color="red" left>mdi-delete</v-icon>
                    Excluir
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <v-dialog v-model="dialog" max-width="600" eager>
      <InvoicesForm
        ref="form"
        :clients="clients"
        @cancel="closeDialog"
        @submit="handleSubmit"
      />
    </v-dialog>
  </Page>
</template>

<script>
import Page from "@/components/layout/Page";
import Service from "@/services/InvoicesService";
import MoneyMixin from "@/mixins/MoneyMixin";
import DateTimeMixin from "@/mixins/DateTimeMixin";
import DataTable from "@/tools/DataTable";
import InvoicesForm from "@/components/forms/InvoicesForm";

const service = new Service();

const options = DataTable.getDefaultOptions("invoice_number", true);

export default {
  components: { Page, InvoicesForm },

  mixins: [MoneyMixin, DateTimeMixin],

  data() {
    return {
      service,
      options,
      totalItems: 0,
      headers: [
        {
          text: "Nro",
          value: "invoice_number",
          width: 120
        },
        {
          text: "Cliente",
          value: "client_name"
        },
        {
          text: "Data",
          value: "date",
          width: 100,
          align: "right"
        },
        {
          text: "Valor",
          value: "amount",
          width: 120,
          align: "right"
        },
        {
          text: "Ações",
          sortable: false,
          align: "right",
          value: "actions",
          width: 130
        }
      ],
      items: [],
      loading: false,
      dialog: false,
      clients: [],
      next_invoice_number: 1
    };
  },

  methods: {
    async handleSubmit(form) {
      this.$refs.form.loading = true;
      await this.service.store(form);
      this.getInvoices();
      this.dialog = false;
      this.$refs.form.loading = false;
    },
    closeDialog() {
      this.dialog = false;
    },
    handleAddInvoice() {
      const initialData = {
        date: this.getTodayString(),
        invoice_number: this.next_invoice_number
      };

      this.dialog = true;
      this.$refs.form.init(initialData, this.next_invoice_number);
    },
    async getInvoices() {
      this.loading = true;
      const table = new DataTable(this.options, "");
      const response = await this.service.index(table.params);
      this.clients = response.meta.clients;
      this.next_invoice_number = response.meta.next_invoice_number;
      await table.fill(response, this);
      this.loading = false;
    },
    async deleteInvoice(id) {
      if (!confirm("Excluir a invoice?")) return;

      await this.service.destroy(id);
      this.getInvoices();
    }
  },

  watch: {
    options: {
      handler() {
        this.getInvoices();
      },
      deep: true
    }
  },

  created() {
    this.getInvoices();
  }
};
</script>
